import React from "react";
import { CheckCircle2, AlertCircle, Clock } from "lucide-react";
import { fmtMoney, relativeTime } from "../lib/format";

/**
 * ReconcileBadge — compact chip showing when this account was last reconciled and whether it balanced.
 * Pass the latest reconcile row for this account (from GET /api/reconcile/latest keyed by account_id).
 */
export default function ReconcileBadge({ latest, testid }) {
  if (!latest) {
    return (
      <span
        data-testid={testid}
        className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#4a4a4a] px-1.5 py-0.5 rounded border border-[#1a1a1a]/40 bg-white/60"
      >
        <Clock size={10} strokeWidth={3} /> Never reconciled
      </span>
    );
  }
  const balanced = !!latest.balanced;
  const bg = balanced ? "#b5e4ca" : "#f4c2c2";
  const Icon = balanced ? CheckCircle2 : AlertCircle;
  const suffix = balanced ? "balanced" : `off ${fmtMoney(latest.difference)}`;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#1a1a1a] px-1.5 py-0.5 rounded border border-[#1a1a1a]"
      style={{ background: bg }}
      title={`Last reconciled ${relativeTime(latest.created_at)} · ${suffix}`}
    >
      <Icon size={10} strokeWidth={3} /> {relativeTime(latest.created_at)} · {suffix}
    </span>
  );
}
